// extracted by mini-css-extract-plugin
export default {"container":"iq-z","heading":"jq-z","text":"kq-z","info":"lq-z","link":"mq-z","fullMaxWidth":"nq-z"};